export enum PropertyManagementCompanyDateFilters {
    CURRENT_MONTH = 'currentMonth',
    LAST_MONTH = 'lastMonth',
    CURRENT_YEAR = 'currentYear',
    LAST_YEAR = 'lastYear',
}
